import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { unifiedLoginUrl } from '../auth/unified';
import PageLayout from './PageLayout';

const CONTENT = {
  login: {
    title: '欢迎回来',
    description: '使用手机号登录，或创建账号后继续测评并查看报告。',
    action: '手机号登录 / 注册',
  },
  register: {
    title: '创建你的测评账号',
    description: '验证手机号后，已有账号将直接登录，新账号会保存你的测评记录与报告。',
    action: '手机号登录 / 注册',
  },
  reset: {
    title: '找回密码',
    description: '在登录页选择“忘记密码？”，按提示通过已验证手机号或邮箱重设密码。',
    action: '前往找回密码',
  },
};

export default function UnifiedEntry({ mode = 'login' }) {
  const { sso, loadUser } = useAuth();
  const content = CONTENT[mode] || CONTENT.login;
  const failed = sso.configurationError;
  const query = new URLSearchParams(window.location.search);
  const returnTo = query.get('returnTo');
  const suffix = returnTo ? '?' + new URLSearchParams({ returnTo }) : '';
  useEffect(() => {
    const previous = document.title;
    document.title = `${failed ? '暂时无法登录' : content.title} · AI 领导力测评`;
    return () => { document.title = previous; };
  }, [content.title, failed]);

  return (
    <PageLayout authPage>
      <div className="unified-entry">
        <section className="unified-intro" aria-labelledby="assessment-intro">
          <span className="unified-wordmark" aria-hidden="true">AIQ</span>
          <p className="unified-eyebrow">前哨科技 · AI 领导力测评</p>
          <h2 id="assessment-intro">了解你的 AI 领导力<br />让成长更有方向</h2>
          <p className="unified-intro-copy">从测评中认识自己，在报告中发现优势与提升空间。</p>
          <ul className="unified-benefits" aria-label="测评账号用途">
            <li>参与测评</li><li>查看报告</li><li>回顾成长</li>
          </ul>
        </section>
        <section className="unified-card" aria-labelledby="entry-title">
          <p className="unified-card-label">AI 领导力测评</p>
          <h1 id="entry-title">{failed ? '暂时无法登录' : content.title}</h1>
          <p className="unified-description" role={failed ? 'alert' : undefined}>
            {failed ? '账号服务暂时连接不上，请稍后重试。' : content.description}
          </p>
          {failed ? (
            <button className="unified-primary-link" type="button" onClick={loadUser}>重新连接</button>
          ) : (
            <a className="unified-primary-link" href={unifiedLoginUrl(mode === 'register' ? 'register' : 'login')}>
              {content.action}<span aria-hidden="true">→</span>
            </a>
          )}
          {!failed && mode === 'login' && <p className="unified-recovery"><Link to={'/reset-password' + suffix}>忘记密码？</Link></p>}
          {!failed && mode === 'register' && <p className="unified-note">收到企业码？可在注册时填写，也可以稍后加入企业。</p>}
          <div className="unified-switch">
            {mode === 'register' ? <>已有账号？<Link to={'/login' + suffix}>立即登录</Link></> :
              mode === 'reset' ? <Link to={'/login' + suffix}>返回登录</Link> :
              <>还没有账号？<Link to={'/register' + suffix}>创建账号</Link></>}
          </div>
        </section>
      </div>
    </PageLayout>
  );
}
